<template>
  <div class="wrap">
    <h1>技能管理 <span class="tip-app">更多技能設置可下載APP</span></h1>
    <div v-if="isLoading" class="loading-wrap">
      <i class="el-icon-loading" />
    </div>
    <div v-else class="skill-list">
      <div
        class="skill-wrap add-skill"
      >
        <div class="add-wrap" @click="addSkill">
          <div class="add-img">
            <fps-icon type="add" size="24" />
          </div>
          <span class="add-text">添加新技能</span>
        </div>
      </div>
      <div
        v-for="(skill, index) in skillList"
        :key="'skill-' + (skill ? skill.id : 'empty')"
        class="skill-wrap one-skill"
      >
        <SkillCard
          v-if="skill"
          :info="skill"
          @changeStatus="changeStatus($event, index)"
          @deleteSkill="deleteSkill(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SkillCard from './skill-card'

export default {
  components: {
    SkillCard,
  },
  data() {
    return {
      isLoading: true,
      skillList: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player'
    }
  },
  created() {
    if (!this.isPlayer) {
      this.$router.go(-1)
      return
    }
    this.getSkillList()
  },
  methods: {
    deleteSkill(index) {
      this.skillList.splice(index, 1)
    },
    changeStatus({ status, skill }, index) {
      skill.settingStatus = status
      this.$set(this.skillList, index, skill)
    },
    addSkill() {
      this.$router.push({
        path: '/settled',
        query: {
          type: 'add'
        }
      })
    },
    getSkillList() {
      this.$http.get('/player/skill/certification/skilllist').then(({ data }) => {
        if (data) {
          let skillList = [].concat(data.Checking || [], data.Checked || [], data.Fail || [], data.Success || [])
          if (skillList.length % 2 === 0) {
            skillList.push('')
          }
          this.skillList = skillList
        }
        this.isLoading = false
      }).catch(err => {
        console.log(err)
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading-wrap {
    display: flex;
    justify-content: center;
    padding: 40px;
    font-size: 24px;
  }
  .wrap {
    padding: 24px 0 40px;
    h1 {
      font-weight: 500;
      font-size: 22px;
      line-height: 31px;
      color: #333333;
    }
  }
  .skill-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 20px;
    user-select: none;
    .skill-wrap {
      margin-top: 15px;
      &>div {
        border: 1px solid $color-split;
        border-radius: 8px;
        background: #FFFFFF;
        border-radius: 8px;
        padding: 16px;
        display: flex;
        width: 482px;
        .add-img {
          width: 72px;
          height: 68px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: $color-button;
          border-radius: 8px;
          margin-right: 12px;
        }
        .add-text {
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          color: $color-gray-1;
        }
        &:active,
        &:hover {
          background: $color-split;
          box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.08);
          border-radius: 8px;
        }
      }
      .add-wrap {
        align-items: center;
      }
    }
  }
  .tip-app {
    margin-left: 36px;
    font-size: 14px;
    color: #666666;
  }
</style>
